import React from 'react'
import { useTranslation } from 'react-i18next'

import cdpqCover from '@src/assets/images/client-cards/cdpq/cover.png'
import cdpqLogo from '@src/assets/images/client-cards/cdpq/logo.png'
import energirCover from '@src/assets/images/client-cards/energir/cover.png'
import energirLogo from '@src/assets/images/client-cards/energir/logo.png'
import hydroQuebecCover from '@src/assets/images/client-cards/hydro-quebec/cover.png'
import hydroQuebecLogo from '@src/assets/images/client-cards/hydro-quebec/logo.svg'
import maletteCover from '@src/assets/images/client-cards/malette/cover.jpeg'
import maletteLogo from '@src/assets/images/client-cards/malette/logo.png'
import pomerleauCover from '@src/assets/images/client-cards/pomerleau/cover.png'
import pomerleauLogo from '@src/assets/images/client-cards/pomerleau/logo.png'
import saintHubertCover from '@src/assets/images/client-cards/saint-hubert/cover.jpeg'
import saintHubertLogo from '@src/assets/images/client-cards/saint-hubert/logo.png'
import viaRailCover from '@src/assets/images/client-cards/via-rail/cover.png'
import viaRailLogo from '@src/assets/images/client-cards/via-rail/logo.png'

import Section from '../common/layout/Section'
import GridLayout from '../revamp/GridLayout'
import ScrollableContainer from '../revamp/ScrollableContainer'

const clientCards = [
  {
    clientName: 'Hydro-Québec',
    color: '#0F0099',
    coverImage: hydroQuebecCover,
    logo: hydroQuebecLogo,
  },
  {
    clientName: 'CDPQ',
    color: '#E5F3FB',
    coverImage: cdpqCover,
    logo: cdpqLogo,
  },
  {
    clientName: 'Pomerleau',
    color: '#000',
    coverImage: pomerleauCover,
    logo: pomerleauLogo,
  },
  {
    clientName: 'Saint-Hubert',
    color: '#000',
    coverImage: saintHubertCover,
    logo: saintHubertLogo,
  },
  {
    clientName: 'Énergir',
    color: '#002855',
    coverImage: energirCover,
    logo: energirLogo,
  },
  {
    clientName: 'Malette',
    color: '#ED1C24',
    coverImage: maletteCover,
    logo: maletteLogo,
  },
  {
    clientName: 'Via Rail',
    color: '#282828',
    coverImage: viaRailCover,
    logo: viaRailLogo,
  },
]

export default function ClientsSection() {
  const { t } = useTranslation('revamp')

  return (
    <Section className='pb-28 pt-20 md:pt-16'>
      <GridLayout breakpoint='sm' className='mb-10 grid items-baseline lg:mb-20'>
        <h2 className='text-r-5xl leading-small font-bold' style={{ maxWidth: '20ch' }}>
          {t('organizationsTitle')}
        </h2>
        <p className='text-r-2xl text-left font-normal' style={{ maxWidth: '60ch' }}>
          {t('organizationsText')}
        </p>
      </GridLayout>
      <article className='flex w-full justify-center'>
        <ScrollableContainer className='my-10 flex flex-row flex-nowrap gap-4 md:gap-8'>
          {clientCards.map(({ clientName, color, coverImage, logo }) => (
            <div className='inline-block' key={clientName}>
              <article
                className='flex h-96 flex-col items-center overflow-hidden rounded-lg'
                style={{ backgroundColor: color, width: '250px' }}
              >
                <img
                  className='rounded-t-lg'
                  src={coverImage}
                  alt={`${clientName} banner`}
                  width={250}
                  height={184}
                />
                <img
                  className='my-auto h-auto'
                  src={logo}
                  alt={`${clientName} logo`}
                  style={{ maxWidth: '228px' }}
                />
              </article>
            </div>
          ))}
        </ScrollableContainer>
      </article>
    </Section>
  )
}
